import {
  Datagrid,
  List,
  TextField,
  Filter,
  TextInput,
  DateField,
  ReferenceField,
} from "react-admin";
import { parentReadMany } from "../../provider/provider";
import XLSX from "xlsx";

// const Aside = () => (
//   <div style={{ width: 200, margin: "1em" }}>
//     <h3>123</h3>
//   </div>
// );

const ReferralFilter = (props) => ( 
  <Filter {...props}>
    <TextInput label="Search by Id" source="id" alwaysOn />
    <TextInput label="Search by Email" source="email" alwaysOn />
    <TextInput label="Search by mobile" source="mobile" alwaysOn />
  </Filter>
);

// export async function ParentExporter() {
//   const users = await parentReadMany("", "", true);
//   console.log(users);
//   const parsedRows = users.data.map((it) => {
//     return {
//       Name: it?.name ?? "",
//       "Mobile Number": it?.mobile ?? "",
//       Email: it?.email ?? "",
//       SignupDate: it.createdAt,
//     };
//   });
//   const worksheet = XLSX.utils.json_to_sheet(parsedRows);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
//   XLSX.writeFile(workbook, "UserExport.xlsx");
// }

export const ReferralList = (props) => {
  return (
    <List
      {...props}
      // exporter={ParentExporter}
      // filters={<ReferralFilter />}
      // aside={<Aside />}
    >
      <Datagrid rowClick="show">
        {/* <TextField source="id" /> */}

        <ReferenceField
          reference="parent"
          source="senderUserId"
          label="Sender Id"
        >
          <TextField source="id" label="Sender Id" />
        </ReferenceField>
        <ReferenceField
          reference="parent"
          source="receiverUserId"
          label="Receiver Id"
        >
          <TextField source="id" label="Receiver Id" />
        </ReferenceField>
        <DateField
          source="createdDate"
          options={{ year: "numeric", month: "long", day: "numeric" }}
        />
      </Datagrid>
    </List>
  );
};
